import React, { Fragment, useEffect, useState } from "react";
import { styled } from "baseui";
import { FormControl } from "baseui/form-control";
import { Input, SIZE as INPUT_SIZES } from "baseui/input";
import { Textarea, SIZE as TEXT_SIZE } from "baseui/textarea";
import {FlexGrid, FlexGridItem} from 'baseui/flex-grid';

const InputDiv = styled(FlexGridItem , {});

export default function TextInputTemplate({
  handleItemPropsChanged,
  ...props
}) {
  const [name, setName] = useState(props.name);
  const [displayName, setDisplayName] = useState(props.displayName);
  const [defaultValue, setDefaultValue] = useState(props.defaultValue);
  const [description, setDescription] = useState(props.description);
  const [error, setError] = useState({...props.errors["common"], ...props.errors["text"]});

  useEffect(() => {
    setName(props.name);
    setDisplayName(props.displayName);
    setDefaultValue(props.defaultValue);
    setDescription(props.description);
  }, [
    props.name,
    props.displayName,
    props.defaultValue,
    props.description,
  ]);
  useEffect(() => {
    setError({...props.errors["common"], ...props.errors["text"]});
  }, [props.errors]);

  function handleItemChange() {
      var item = {
        id: props.id,
        name: name,
        displayName: displayName,
        defaultValue: defaultValue,
        description: description,
      };
      handleItemPropsChanged(props.type, item);
  }

  return (
    <Fragment>
      <FlexGrid
             flexGridColumnCount={[1, 2, 2, 3]}
             flexGridColumnGap="scale800"
      >
        <InputDiv>
          <FormControl
            label="Parameter name"
            caption={error.name ? "Parameter name should be alphanumeric and unique" : ""}
            error={error.name}
          >
            <Input
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setName(e.target.value)}
              value={name}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl label="Display name">
            <Input
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setDisplayName(e.target.value)}
              value={displayName}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl
            label="Default value"
            caption={error.defaultValue ? "Default value is required." : ""}
            error={error.defaultValue}
          >
            <Input
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setDefaultValue(e.target.value)}
              value={defaultValue}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
      </FlexGrid>
      <div>
        <FormControl label="Description">
          <Textarea
            disabled={!props.isSelected}
            onBlur={handleItemChange}
            onChange={(e) => setDescription(e.target.value)}
            value={description || ""}
            size={TEXT_SIZE.mini}
            clearOnEscape
          />
        </FormControl>
      </div>
    </Fragment>
  );
}
